import { render, staticRenderFns } from "./publicityDialog.vue?vue&type=template&id=2980461e&scoped=true"
import script from "./publicityDialog.vue?vue&type=script&lang=ts"
export * from "./publicityDialog.vue?vue&type=script&lang=ts"
import style0 from "./publicityDialog.vue?vue&type=style&index=0&id=2980461e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980461e",
  null
  
)

export default component.exports